export default "__VITE_ASSET__b0085622__"